import React, { FC } from 'react';
import { RouteComponentProps, Switch, Redirect } from 'react-router-dom';
import { CONFIG_BASE_PATH, CONFIG_CAMPAIGN_CATEGORY_PATH } from '../../constants';
import PruRoute from '../../../../common/components/PruRoute';
import ConfigCampaignCategoryDetailPage from './View/ConfigCampaignCategoryDetailPage';
import ConfigCampaignCategoryListingPage from './List/ConfigCampaignCategoryListingPage';
import { ModulePermissionProps } from '../../../../common/module/types';

export const configCampaignCategoryPath = `${CONFIG_BASE_PATH}${CONFIG_CAMPAIGN_CATEGORY_PATH}`;

const ConfigCampaignCategoryPage: FC<RouteComponentProps & ModulePermissionProps> = () => {
  return (
    <Switch>
      <Redirect exact from={configCampaignCategoryPath} to={`${configCampaignCategoryPath}/list`} />
      <PruRoute exact path={`${configCampaignCategoryPath}/list`} component={ConfigCampaignCategoryListingPage} />
      <PruRoute exact path={`${configCampaignCategoryPath}/edit/:id`} component={ConfigCampaignCategoryDetailPage} />
      <PruRoute exact path={`${configCampaignCategoryPath}/create`} component={ConfigCampaignCategoryDetailPage} />
    </Switch>
  );
};

export default ConfigCampaignCategoryPage;
